<template>
    <v-card class="mx-auto py-0">
        <v-list dense>
            <v-list-item-group
                v-model="model"
                multiple
                @change="selectInstructor"
            >
                <template v-for="(item, i) in items">
                    <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>

                    <v-list-item
                        :disabled="$_.get(item, 'students_count', 0) > 0"
                        class="list-item"
                        v-else
                        :key="`item-${i}`"
                        :value="item"
                        active-class="list-item-active"
                    >
                        <template v-slot:default="{ active }">
                            <v-list-item-icon>
                                <v-avatar size="40">
                                    <v-img
                                        :src="item.profile_photo_url"
                                    ></v-img>
                                </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ item.name }}
                                    <v-chip
                                        class="ml-2"
                                        label
                                        small
                                        color="primary lighten-2"
                                        >Students:
                                        {{ item.students_count }}</v-chip
                                    >
                                </v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-action>
                                <v-checkbox
                                    :input-value="active"
                                    color="primary darken-2"
                                    :disabled="item.students_count > 0"
                                ></v-checkbox>
                            </v-list-item-action>
                        </template>
                    </v-list-item>
                </template>
            </v-list-item-group>
        </v-list>
    </v-card>
</template>

<script>
export default {
    name: "instructors-select-list",
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            model: [],
        };
    },
    watch: {
        items: {
            immediate: true,
            handler(items) {
                this.model = items.filter((item) => item.hasSession);
            },
        },
    },
    methods: {
        selectInstructor(instructors) {
            this.$emit("select-instructor", instructors);
        },
    },
};
</script>

<style scoped>
.list-item:hover {
    background: var(--v-secondary-lighten2);
}
.list-group:hover {
    background: var(--v-secondary-lighten2);
}

.v-list-group--active:hover {
    background: white !important;
}
.v-list-group--active .list-item:hover {
    background: var(--v-secondary-lighten4);
    color: var(--v-primary-darken2);
}
.v-list-group--active .list-item:hover .list-item-text {
    color: var(--v-primary-darken2);
}

.list-item:hover .list-item-text {
    color: white;
}
.list-item-active:hover {
    background: white !important;
}
.list-item-active {
    background: white !important;
}
</style>